import NetMsgDataToBuffer from "../../../framework/net/net_msgdata_to_buffer";
import { BlackJack } from "./proto/proto_blackjack_game";
import { Room } from "../../table/net/proto/proto_poker_room";




export class NetMsgBlackJack extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //登陆或重连发送的数据
    static GameInfo: any[] = [null, null, "Game.GameInfo",BlackJack.GameInfo, 3];

    //下注
    static BetChip: any[] = ["Game.BetReq", BlackJack.BetReq, "Game.BetRsp", BlackJack.BetRsp, 3]

    //下注通知
    static BetNotify: any[] = [null, null, "Game.BetNotify",BlackJack.BetNotify, 3];

    

    //落座和旁观 申请
    static OccupySeat: any[] = ["Game.OccupySeatReq", BlackJack.OccupySeatReq, "Game.OccupySeatRsp", BlackJack.OccupySeatRsp, 3]

    //落座通知
    static OccupySeatNotify: any[] = [null, null, "Game.OccupySeatNotify",BlackJack.OccupySeatNotify, 3];

    //发牌通知
    static DealCardNotify: any[] = [null, null, "Game.DealCardNotify",BlackJack.DealCardNotify, 3]

    //双倍申请 DoubleBetReq
    static DoubleBet: any[] = ["Game.DoubleBetReq", BlackJack.DoubleBetReq, "Game.DoubleBetRsp", BlackJack.DoubleBetRsp, 3]

    //双倍通知
    static DoubleBetNotify: any[] = [null, null, "Game.DoubleBetNotify",BlackJack.DoubleBetNotify, 3];

    //分牌申请
    static EnableRight: any[] = ["Game.EnableRightReq", BlackJack.EnableRightReq, "Game.EnableRightRsp", BlackJack.EnableRightRsp, 3]

    //分牌通知 EnableRightNotify
    static EnableRightNotify: any[] = [null, null, "Game.EnableRightNotify",BlackJack.EnableRightNotify, 3];

    //要牌申请 MoreCardReq
    static MoreCard: any[] = ["Game.MoreCardReq", BlackJack.MoreCardReq, "Game.MoreCardRsp", BlackJack.MoreCardRsp, 3]

    //要牌通知
    static MoreCardNotify: any[] = [null, null, "Game.MoreCardNotify",BlackJack.MoreCardNotify, 3];

    // 停牌申请 NoMoreCardReq
    static NoMoreCard: any[] = ["Game.NoMoreCardReq", BlackJack.NoMoreCardReq, "Game.NoMoreCardRsp", BlackJack.NoMoreCardRsp, 3]


    // 停牌通知 NoMoreCardNotify
    static NoMoreCardNotify: any[] = [null, null, "Game.NoMoreCardNotify",BlackJack.NoMoreCardNotify, 3];

    //保险申请 InsuranceReq
    static Insurance: any[] = ["Game.InsuranceReq", BlackJack.InsuranceReq, "Game.InsuranceRsp", BlackJack.InsuranceRsp, 3]

    //保险通知 InsuranceNotify
    static InsuranceNotify: any[] = [null, null, "Game.InsuranceNotify",BlackJack.InsuranceNotify, 3];

    //特殊结算
    static GameSettle: any[] = [null, null, "Game.GameSettle",BlackJack.GameSettle, 3];

    //倒计时 TimeoutNotify
    static TimeoutNotify: any[] = [null, null, "Game.TimeoutNotify",BlackJack.TimeoutNotify, 3];

    static LeaveRoom: any[] = ["Room.LeaveReq", Room.LeaveReq, "Room.LeaveRsp", Room.LeaveRsp, 3]
    
    static LeaveRoomNotify: any[] = [null, null, "Room.LeaveBroadcast", Room.LeaveBroadcast, 3]

    //庄家发牌
    static BankerDealCardNotify: any[] = [null, null, "Game.BankerDealCardNotify",BlackJack.BankerDealCardNotify, 3];

    //未下注提醒
    static NoBetNotify: any[] = [null, null, "Game.NoBetNotify",BlackJack.NoBetNotify, 3];

    // 下注完成申请
    static BetFinish: any[] = ["Game.BetFinishReq", BlackJack.BetFinishReq, "Game.BetFinishRsp", BlackJack.BetFinishRsp, 3]

    //下注完成通知
    static BetFinishNotify: any[] = [null, null, "Game.BetFinishNotify",BlackJack.BetFinishNotify, 3];

    //发送节奏控制
    static AckReq: any[] = ["Game.AckReq",BlackJack.AckReq,null,null, 3];

}